import { defineStore } from 'pinia'

export const useBrowserStore = defineStore('browser', () => {

  const getFullKey = (key: string) => `ara_${key}`

  const addToCookie = (key: string, data: any) => {
    try {
      const cookie = useCookie(getFullKey(key), {
        maxAge: 60 * 60 * 24 * 7, 
        path: '/',
        watch: true
      })
      cookie.value = data
      return true
    } catch {
      return false
    }
  }

  const getFromCookie = <T>(key: string): T | null => {
    try {
      const cookie = useCookie<T>(getFullKey(key))
      return cookie.value ?? null
    } catch {
      return null
    }
  }
  const removeFromCookie = (key: string) => {
    const cookie = useCookie(getFullKey(key))
    cookie.value = null // Setting to null deletes the cookie
  }

  const removeFromSession = (key: string) => {
    if (import.meta.client) sessionStorage.removeItem(getFullKey(key))
  }
  const clearSession = () => {
    if (import.meta.client) sessionStorage.clear();
  }

  const clearAllCookies = () => {
  if (!import.meta.client) return

  const cookies = document.cookie.split("; ")

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=")
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    
    if (name.startsWith('ara_')) {
      const c = useCookie(name)
      c.value = null
    }
  }
}

  const addToLocal = (key: string, data: any, isStringified: boolean = true) => {
    if (!import.meta.client) return false
    try {
      const value = isStringified ? data : JSON.stringify(data)
      localStorage.setItem(getFullKey(key), value)
      return true
    } catch {
      return false
    }
  }

  const getFromLocal = <T>(key: string, parseToJSON: boolean = false): T | string | null => {
    if (!import.meta.client) return null
    try {
      const data = localStorage.getItem(getFullKey(key))
      if (data === null) return null
      return parseToJSON ? (JSON.parse(data) as T) : data
    } catch {
      return null
    }
  }

  const removeFromLocal = (key: string) => {
    if (import.meta.client) localStorage.removeItem(getFullKey(key))
  }
  const clearLocal = () => {
    if (import.meta.client) localStorage.clear();
  }

  return {
    addToCookie,
    getFromCookie,
    removeFromCookie,
    removeFromSession,
    clearSession,
    clearAllCookies,
    addToLocal,
    getFromLocal,
    removeFromLocal,
    clearLocal
  }
})